
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[referralCode]/[alias]",
      function () {
        return require("private-next-pages/p/[referralCode]/[alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[referralCode]/[alias]"])
      });
    }
  